import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  async softUpdate(form) {
    try {
      const formData = new FormData(form);

      // updates without file upload
      await this._submitUpdate(formData, form.action);
    } catch (error) {
      this._dispatchError(error.message);
    }
  }

  async uploadAndUpdateCourse(authToken, form, params) {
    try {
      await this._handleUploadFile(authToken, form, params);
    } catch (error) {
      this._dispatchError(`${params['errorMessage']}: ${error.message}`);
    }
  }

  async _handleUploadFile(authToken, form, params) {
    try {
      const baseUrl = `${params['uploadUrl']}&mayCreateNewVersion=true`;
      let url = baseUrl;

      const formData = new FormData(form);

      if (params['usePostbackParam'] && params['postbackUrl']) {
        const encoded = encodeURIComponent(params['postbackUrl']);
        url = `${baseUrl}&postbackUrl=${encoded}`;
      }

      void this._uploadFile(authToken, formData, url);

      formData.append("has_upload", true);
      await this._submitUpdate(formData, form.action);
    } catch (error) {
      this._dispatchError(`${params['errorMessage']}: ${error.message}`);
    }
  }

  async _uploadFile(authToken, formData, scormUploadUrl) {
    const response = await fetch(scormUploadUrl, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`
      },
      body: formData
    });

    return response.json().catch(() => ({}));
  }

  async _submitUpdate(formData, path) {
    // Even though this file param is not used in the update action,
    // we need to remove it since we can have errors related to file size limit
    formData.delete("file");

    return new Promise((resolve, reject) => {
      Rails.ajax({
        url: path,
        type: 'PATCH',
        data: formData,
        processData: false,
        success: (data) =>  {
          if (data.redirect_url) {
            window.location = data.redirect_url;
          }
          resolve(data);
        },
        error: (xhr, status, error) => reject(error),
      });
    });
  }

  _dispatchError(message) {
    document.dispatchEvent(new CustomEvent('promote:display-error-message', {
      detail: {
        message: message
      }
    }));
  }
}
